import { Validator } from '../../types/Validator';
import { ValidatorInterface } from '../../types/ValidatorInterface';
import { ValidatorRegistry } from '../../types/ValidatorRegistry';
import { PropertiesInterface } from '../../types/properties/Property';
import { ITypeValidatesLessThan } from './ITypeValidatesLessThan';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use LessThanValidator from application-types instead.
 */
export class LessThanValidator
  implements ValidatorInterface<ITypeValidatesLessThan> {
  name = 'LessThan';

  friendlyName = 'Less Than';

  arrayOnly = false;

  array = false;

  description = 'Field must be less than this other field.';

  types = ['Percentage', 'Currency', 'Number', 'DateTime', 'Time', 'Date'];

  properties = {
    value: {
      type: 'Key',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  attach(type: ITypeValidatesLessThan) {
    type.addLessThanValidator(this);
  }

  constructor(public config?: Validator) {}
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use LessThan from application-types instead.
 */
const LessThan = new LessThanValidator(undefined);

ValidatorRegistry.register(LessThanValidator, LessThan.name);

export default LessThan;
